import React, { FC } from 'react';
import { useTable, Row, Column } from 'react-table';
import { css, cx } from '../customEmotion';

const StyledEditableTable = css`
	table, th, td {
		border: 1px solid #eeeeee;
	}

  table {
    width: 100%;
		border-collapse: collapse;
		table-layout:fixed;
	}

  thead {
		tr th {
			height: 56px;
			font-size: 14px;
			font-weight: 500;
			text-align: center;
			color: #3dba90;

			&:#title {
				width: 20%;
			}

			&#origin {
				width: 40%;
			}

			&#translate {
				width: 40%;
			}
		}
	}

	tbody {
		tr td {
			word-break:break-word;
			vertical-align:top;
		}
	}
`;

interface EditableTableProps {
	rows: Row[];
	columns: Column<Row>[];
}

const EditableTable: FC<EditableTableProps> = ({ rows, columns }) => {
	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		rows: instanceRows,
		prepareRow,
	} = useTable({ columns, data: rows });

	return (
		<div className={cx(StyledEditableTable)}>
			<table {...getTableProps()}>
				<thead>
					{
						headerGroups.map(headerGroup => (
							<tr {...headerGroup.getHeaderGroupProps()}>
								{
									headerGroup.headers.map(column => (
										<th id={column.id} {...column.getHeaderProps()}>{ column.render('Header') }</th>
									))
								}
							</tr>
						))
					}
				</thead>
				<tbody {...getTableBodyProps}>
					{
						instanceRows.map(row => {
							prepareRow(row);
							return (
								<tr {...row.getRowProps()}>
									{
										row.cells.map(cell => {
											return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
										})
									}
								</tr>
							);
						})
					}
				</tbody>
			</table>
		</div>
	);
};

export default EditableTable;
